import { defineComponent as _defineComponent } from 'vue';
import { BCard, BCardText } from "bootstrap-vue";
import IncludedBadge from "./IncludedBadge.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExportRecordCard',
    props: {
        exportRecord: null
    },
    setup(__props) {
        const props = __props;
        return { __sfc: true, props, BCard, BCardText, IncludedBadge };
    }
});
